import { DateTime } from "luxon";

export type TZOption = { label: string; value: string; offsetMinutes: number };

export function getTimezoneOptions(now = DateTime.now()): TZOption[] {
  // Fallback list if a very old browser doesn’t support supportedValuesOf
  const fallback = ["UTC", "Asia/Manila", "Asia/Bahrain", "Australia/Sydney", "Australia/Brisbane", "Australia/Perth", "Australia/Adelaide", ];

  const zones: string[] =
    (Intl as any).supportedValuesOf?.("timeZone") ?? fallback;

  const toLabel = (tz: string) => {
    const dt = now.setZone(tz);
    const mins = dt.offset; // minutes from UTC, handles DST automatically
    const sign = mins >= 0 ? "+" : "-";
    const hh = String(Math.floor(Math.abs(mins) / 60)).padStart(2, "0");
    const mm = String(Math.abs(mins) % 60).padStart(2, "0");
    return tz === "UTC" ? "UTC" : `${tz} (GMT${sign}${hh}:${mm})`;
  };

  return zones
    .map((tz) => ({
      label: toLabel(tz),
      value: tz,            // <- store/send this to backend
      offsetMinutes: now.setZone(tz).offset,
    }))
    // Sort by current offset, then alphabetically (nice UX)
    .sort(
      (a, b) =>
        a.offsetMinutes - b.offsetMinutes ||
        a.label.localeCompare(b.label)
    );
}
